export class ActiveDto {
    password: string;
    passwordConfirm: string;

    constructor() { }
}
